export default {
    documentStatus: {
        complete: 'Complete',
        pending: 'Pending',
        error: 'Error',
    },
    containerStatus: {
        draft: 'Draft',
        booked: 'Booked',
        inTransit: 'In Transit',
        arrived: 'Arrived',
        delivered: 'Delivered',
        onHold: 'On Hold',
        cancelled: 'Cancelled',
    },
    // Physical container status (new 2025 model)
    containerPhysicalStatus: {
        PENDING: 'Pending',
        GATE_OUT_EMPTY: 'Gate Out (Empty)',
        LOADING: 'Loading',
        GATE_IN: 'Gate In',
        LOAD_ON_VESSEL: 'Loaded on Vessel',
        VESSEL_DEPARTED: 'Vessel Departed',
        IN_TRANSIT: 'In Transit',
        VESSEL_ARRIVED: 'Vessel Arrived',
        DISCHARGED: 'Discharged',
        GATE_OUT_DELIVERY: 'Gate Out (Delivery)',
        DELIVERED: 'Delivered',
        ON_HOLD: 'On Hold',
        CANCELLED: 'Cancelled',
    },
    // Booking status
    bookingStatus: {
        DRAFT: 'Draft',
        CONFIRMED: 'Confirmed',
        IN_PROGRESS: 'In Progress',
        COMPLETED: 'Completed',
        CANCELLED: 'Cancelled',
    },
    riskLevel: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical',
    },
    documentType: {
        billOfLading: 'Bill of Lading',
        invoice: 'Commercial Invoice',
        phytosanitaryCertificate: 'Phytosanitary Certificate',
        movementCertificate: 'EUR.1 Movement Certificate',
        packingList: 'Packing List',
        fumigationCertificate: 'Fumigation Certificate',
        sadIcm: 'SAD/ICM',
        coo: 'Certificate of Origin',
        unknown: 'Unknown Document',
    },
    roles: {
        shipper: 'Shipper',
        consignee: 'Consignee',
        receiver: 'Receiver',
        notifyParty: 'Notify Party',
        freightForwarder: 'Freight Forwarder',
        forwarder: 'Forwarder',
        carrier: 'Carrier',
        shipOwner: 'Ship Owner',
        landTransport: 'Land Transport',
        customsBroker: 'Customs Broker',
        portOfLoading: 'Port of Loading',
        portOfDischarge: 'Port of Discharge',
        airportStaff: 'Airport Staff',
        authority: 'Authority',
        insuranceProvider: 'Insurance Provider',
        inspectionAgency: 'Inspection Agency',
        sales: 'Sales',
        supplier: 'Supplier',
    },
    status: {
        active: 'Active',
        pending: 'Pending',
        rejected: 'Rejected',
        suspended: 'Suspended',
        inactive: 'Inactive',
        accepted: 'Accepted',
        modified: 'Modified',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Viewer',
    },
};

